<template>
  <div
       class="details-content look-details">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title"
              @click="toStandActivity">展位竞价/</span>竞价详情
      </template>
      <template v-slot:content>
        <div class="form">
          <el-form ref="form" :model="form" label-width="100px">
            <div class="flex">
              <el-form-item label="商品筛选：" prop="goodsName">
                <el-input
                  class="white w160"
                  v-model="form.goodsName"
                  clearable
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="商品从属：" prop="supplierId">
                <el-select
                  class="white"
                  clearable
                  placeholder="请选择商品从属"
                  v-model="form.supplierId"
                >
                  <el-option
                    v-for="(item, index) in supplierList"
                    :key="index"
                    :label="item.head"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item class="searchBtn">
              <el-button class="btn-blue" @click="screen">筛选</el-button>
              <el-button
                type="text"
                class="btn-text"
                @click="resetForm('form')"
                >清空筛选条件</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <section class="content base-info"
                 ref="baseInfo">
          <div class="content-title">基础信息</div>
          <div class="content-baseInfo">
            <ul class="content-info">
              <li class="item"><span class="desc">竞价序号：</span>{{standDetail.index}}</li>
              <li class="item"><span class="desc">起拍价格：</span>￥{{standDetail.basePrice}}</li>
              <li class="item"><span class="desc">到期时间：</span>{{standDetail.overdueTime}}</li>
              <li class="item"><span class="desc">竞价时间：</span>{{standDetail.beginTime}} - {{standDetail.endTime}}</li>
            </ul>
          </div>
        </section>
        <section class="content customer-info">
          <div class="content-title">竞价商品</div>
          <div class="out-container">
            <div class="table">
              <el-table class="table-container"
                        :data="standDetailsList">
                <el-table-column label="商品名称"
                                 prop="goodsName"></el-table-column>
                <el-table-column label="商品从属"
                                 prop="supplierName"></el-table-column>
                <el-table-column label="竞价金额"
                                 prop="biddingPrice"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1?(standDetail.biddingStatus == 3?isChoice:false):false"
                      class="btn-text"
                      type="text"
                      @click="choice(scope.row.id)"
                    >选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="total"
                :currentPage="currentPage"
                @queryChange="searchBiddingDetails">
              </pagination-tpl>
            </div>
          </div>
        </section>
        <div class="operations" ref="operations">
          <el-button class="btn-white" @click="toStandActivity">返回</el-button>
          <el-button
          v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1"
          class="btn-blue" @click="cancel">取消竞价</el-button>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import { getDBOperationPermission } from 'common/js/storage';
import { formaTimeToSecond } from 'common/js/util.js';
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationTpl from 'base/PaginationTpl';
import DBStandActivity from "models/db/standActivity.js";
import Apply from "models/db/apply";
const apply = new Apply();
const dBStandActivity = new DBStandActivity();
export default {
  data() {
    return {
      // 页面按钮权限
      operationsBtns: {
        roleSaleBoothManage: "ROLE_SALE_booth_manage"
      },
      // 竞价详情相关信息
      standDetail: {},
      // 竞价商品总条数
      total: 0,
      currentPage: 1,
      // 展位竞价商品列表
      standDetailsList: [],
      form: {
        goodsName: "",
        supplierId: ""
      },
      supplierList: [], //商品从属
      isChoice: true,
      standId: null, //展位id
      cateId: null
    };
  },
  methods: {
    // 筛选商品
    screen() {
      this.currentPage = 1;
      this._getStandGoods();
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.screen();
    },
    // 翻页
    searchBiddingDetails(query) {
      this.currentPage = query.currentPage
      this._getStandGoods();
    },
    toStandActivity() {
      this.$router.push({
        path: "/admin/marketing/stand-activity/standActivity",
        query: {
          cateId: this.cateId
        }
      });
    },
    //获取商品列表
    _getStandGoods() {
      let currentPage = this.currentPage
      let goodsName = this.form.goodsName
      let supplierId = this.form.supplierId
      dBStandActivity.getStandGoods(this.standId, currentPage, goodsName, supplierId).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.goodsName = i.goodsName
            obj.supplierName = i.supplierName
            obj.biddingPrice = i.biddingPrice
            arr.push(obj)
          })
          this.standDetailsList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    choice(id) {
      this.$confirm("是否选择该商品上架?", "选择", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'bidding-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      })
        .then(() => {
          let data = { id };
          dBStandActivity.standSelect(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '上架成功'
              });
              this.isChoice = false
              this._getStandGoods();
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          });
        })
    },
    //获取基础信息
    getBaseInfo() {
      dBStandActivity.getBaseInfo(this.standId).then(res => {
        if (res.success) {
          let obj = {}
          obj.id = res.result.id;
          obj.index = res.result.index;
          obj.overdueTime = formaTimeToSecond(res.result.overdueTime);
          obj.beginTime = formaTimeToSecond(res.result.beginTime);
          obj.endTime = formaTimeToSecond(res.result.endTime);
          obj.basePrice = res.result.basePrice;
          obj.biddingStatus = res.result.biddingStatus;
          this.standDetail = obj
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      })
    },
    // 获取商品从属
    getSupplierList() {
      apply.getSupplierList().then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.head = value.head;
            tableData.push(obj);
          });
          this.supplierList = tableData;
        }
      });
    },
    //取消竞价
    cancel() {
      this.$confirm("是否取消该展位竞价?", "取消竞价", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'bidding-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      })
        .then(() => {
          let data = { id: this.standId };
          dBStandActivity.removeStand(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '展位取消成功'
              });
              // this._getStandGoods();
              this.$router.go(-1)
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          });
        })
    }
  },
  created() {
    this.operationList = getDBOperationPermission();
    this.standId = this.$route.query.standId
    this.cateId = Number(this.$route.query.cateId)
    this._getStandGoods()
    this.getBaseInfo()
    this.getSupplierList()
  },
  mounted() {
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.look-details {
  .form {
    padding-top: 16px;
    background: rgba(245, 247, 250, 1);
    .flex {
      display: inline-block;
    }
    .el-form-item {
      height: 32px;
      display: inline-block;
    }
    .el-form-item__label {
      padding: 0;
    }
    .w160 {
      width: 160px;
      height: 32px;
      line-height: 32px;
      .el-input__suffix {
        height: 40px;
        top: -3px;
        right: 0px;
      }
      .el-input__inner {
        height: 32px;
        background: #fff;
      }
    }
    .w96 {
      width: 96px;
    }
    .w280 {
      .el-form-item__content {
        display: flex;
        .el-select {
          width: 96px;
          margin-right: 24px;
        }
        > .el-input {
          width: 160px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.look-details {
  .searchBtn {
    .el-form-item__content {
      margin-left: 30px!important;
    }
  }
  .link-content-inner-container > .content {
    margin-top: 0px;
  }
}
</style>